
// filepath: c:\LELO\Client-Management\apps\frontend\client-management\src\app\material.module.ts
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Import other Material modules as needed

@NgModule({
  exports: [
    MatButtonModule,
    MatToolbarModule,
        MatSidenavModule,
    MatListModule,
    MatIconModule,MatDialogModule ,BrowserAnimationsModule,
  
    // Export other Material modules here
  ]
})
export class MaterialModule {}